export function getAccessibleLocationIds(user: any): number[] | 'all' {
  if (!user) return [];
  if (user.isAdmin === true) return 'all';

  const ids: number[] = [];
  if (Array.isArray(user.isLocationAdminMyTasks)) ids.push(...user.isLocationAdminMyTasks);
  else if (user.isLocationAdminMyTasks === true) return 'all';

  if (Array.isArray(user.isLocationEditorMyTasks)) ids.push(...user.isLocationEditorMyTasks);
  else if (user.isLocationEditorMyTasks === true) return 'all';

  return [...new Set(ids)];
}

export function hasLocationAccess(user: any, locationId: number | null | undefined): boolean {
  if (!locationId) return false;
  const ids = getAccessibleLocationIds(user);
  if (ids === 'all') return true;
  return ids.includes(locationId);
}

export function isLocationOwner(user: any, locationId: number | null | undefined): boolean {
  if (!user || !locationId) return false;
  if (user.isAdmin === true) return true;
  if (user.isLocationAdminMyTasks === true) return true;
  if (Array.isArray(user.isLocationAdminMyTasks)) {
    return user.isLocationAdminMyTasks.includes(locationId);
  }
  return false;
}

export function canDeleteAudit(user: any, locationId: number | null | undefined): boolean {
  if (!user) return false;
  if (user.isAdmin === true) return true;
  if (!locationId) return false;
  return user.hasFactoryAdminRole === true && hasLocationAccess(user, locationId);
}
